<div class="flex-column menu-container">
  <div class="toggle-row">
    <span mat-dialog-title> {{ data.title | translate }}</span>
    @if (data.isBakersEnabled && data.recipeCategory === 'Bakery') {
      <mat-checkbox
        class="include-bakers-checkbox"
        [(ngModel)]="includeBakers"
        (click)="deselectItemChange()"
      >
        {{ "includeBakers" | translate }}
      </mat-checkbox>
    }
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  @let content =
    data.isBakersEnabled && includeBakers()
      ? "selectThreeFormulasToInclude"
      : data.subtitle;
  <mat-dialog-content>{{ content ?? "" | translate }}</mat-dialog-content>

  @if (data.input) {
    <app-people-picker
      (selectedUserMailChange)="selectedPeoples($event)"
      mat-dialog-content
    />
  }
  @for (toggle of data.toggles; track toggle.label) {
    <div class="toggle-row" mat-dialog-content>
      <div class="flex-column">
        <span class="toggle-label">{{ toggle.label | translate }}</span>
        <span class="toggle-subtext">{{
          toggle.subText ?? "" | translate
        }}</span>
      </div>
      <span class="toggle-status">{{
        (toggles[toggle.label] ? "yes" : "no") | translate
      }}</span>
      <mat-slide-toggle
        [(ngModel)]="toggles[toggle.label]"
        [disabled]="toggle.disabled ?? false"
      />
    </div>
  }

  @if (data.list) {
    <div class="scroll-Container">
      <mat-selection-list
        [(ngModel)]="selectedItems"
        [multiple]="true"
        mat-dialog-content
      >
        @for (item of data.list; track $index) {
          <mat-list-option
            [value]="item.recipeVariantId"
            class="list-content"
            (click)="isDisabled($index, $event)"
            [selected]="$index === 0"
            [disabled]="
              $index === 0 ||
              (selectedItems.length > (includeBakers() ? 3 : 4) &&
                !selectedItems.includes(item.recipeVariantId))
            "
          >
            <div class="variant-item">
              <span
                class="selection-list"
                [title]="data.list[$index].variantTypeName"
              >
                {{ data.list[$index].variantTypeName }}
              </span>
              @if ($index === 0) {
                <span class="selection-subtext-firstItem">{{
                  data.subList?.[$index]
                }}</span>
              } @else {
                <span class="selection-subtext">{{
                  data.subList?.[$index]
                }}</span>
              }
            </div>
          </mat-list-option>
          <mat-divider />
        }
      </mat-selection-list>
    </div>
  }

  <mat-dialog-actions align="start">
    @for (btn of data.buttons; track btn.text) {
      @if (btn.color === "primary") {
        <button
          mat-flat-button
          (click)="action(btn.action)"
          class="button-field"
        >
          <span class="material-symbols-outlined">{{ btn.icon }}</span>
          {{ btn.text | translate }}
        </button>
      } @else {
        <button
          mat-flat-button
          class="secondary-button"
          (click)="action(btn.action)"
        >
          <span class="material-symbols-outlined">{{ btn.icon }}</span>
          {{ btn.text | translate }}
        </button>
      }
    }
  </mat-dialog-actions>
</div>
